define('home/views/SettingsLayout',[
    'underscore',

    'core/bus',
    'core/strings',

    'home/collections/SettingsAppCollection',
    'home/collections/SettingsBlockListCollection',

    'core/UniqueModel',
    'home/models/SettingsModeration',
    'home/models/SettingsProfile',
    'home/models/SettingsAccount',
    'home/models/SettingsEmailNotifications',
    'home/views/common/TabbedView',
    'home/views/SettingsBlockingView',
    'home/views/SettingsDeleteView',
    'home/views/SettingsProfileView',
    'home/views/SettingsMenuView',
    'home/views/SettingsAccountView',
    'home/views/SettingsEmailView',
    'home/views/SettingsWebView',
    'home/views/SettingsAppsView',
    'home/views/SettingsModerationView',
    'home/mixins/withEmailVerificationAlert',

    'home/templates/settings',

], function (
    _,

    bus,
    strings,

    SettingsAppCollection,
    SettingsBlockListCollection,

    UniqueModel,
    SettingsModeration,
    SettingsProfile,
    SettingsAccount,
    SettingsEmailNotifications,
    TabbedView,
    SettingsBlockingView,
    SettingsDeleteView,
    SettingsProfileView,
    SettingsMenuView,
    SettingsAccountView,
    SettingsEmailView,
    SettingsWebView,
    SettingsAppsView,
    SettingsModerationView,
    withEmailVerificationAlert,

    settingsTemplate
) {
    'use strict';

    var gettext = strings.get;

    var SettingsLayout = TabbedView.extend({
        defaultTab: 'menu',

        template: settingsTemplate,

        initialize: function (options) {
            this.session = options.session;
            this.user = this.session.user;

            // ensure these collections are created and fetched only once
            this.getSettingsAppCollection = _.once(this.getSettingsAppCollection);
            this.getNotificationFilters = _.once(this.getNotificationFilters);

            // Update layout's class on tab change so that we can vary css on mobile vs desktop:
            // Mobile:
            //  - for root settings page (/menu), only the left menu bar is shown
            //  - for each individual settings page, the left menu bar isn't shown
            // Desktop
            //  - for all settings pages, the left menu bar is always shown
            this.listenTo(this, 'change:activeTab', this.updateLayoutClass);

            this.listenTo(this, 'change:activeTab', this.trackOpenSection);

            TabbedView.prototype.initialize.apply(this, arguments);
        },

        updateLayoutClass: function () {
            this.$el.find('[data-role=settings-layout]')
                    .removeClass('settings--root settings--page')
                    .addClass(
                        this.activeTab === this.defaultTab ? 'settings--root' : 'settings--page'
                    );
        },

        getMetaAttrs: function () {
            return gettext('Settings');
        },

        getSettingsAppCollection: function () {
            var apps = new SettingsAppCollection();
            apps.fetch({ reset: true });
            return apps;
        },

        getNotificationFilters: function () {
            var notifications = this.session.getOrCreateNotifications();
            notifications.filters.fetch({ reset: true });
            return notifications.filters;
        },

        getSettingsBlockListCollection: function () {
            var blockList = new SettingsBlockListCollection();
            blockList.fetch();
            return blockList;
        },

        getTabView: function (activeTab) {
            switch (activeTab) {
            case 'menu':
                return new SettingsMenuView({
                    model: this.session.user,
                });
            case 'profile':
                return new SettingsProfileView({
                    model: new UniqueModel(
                        SettingsProfile,
                        { id: this.session.user.id }
                    ),
                });
            case 'account':
                return new SettingsAccountView({
                    session: this.session,
                    model: new UniqueModel(
                        SettingsAccount,
                        { id: this.session.user.id }
                    ),
                });
            case 'email':
                return new SettingsEmailView({
                    model: new UniqueModel(
                        SettingsEmailNotifications,
                        { id: this.session.user.id }
                    ),
                });
            case 'web':
                return new SettingsWebView({
                    collection: this.getNotificationFilters(),
                });
            case 'apps':
                return new SettingsAppsView({
                    collection: this.getSettingsAppCollection(),
                });
            case 'moderation':
                return new SettingsModerationView({
                    model: new UniqueModel(
                        SettingsModeration,
                        { id: this.session.user.id }
                    ),
                });
            case 'delete':
                return new SettingsDeleteView({
                    session: this.session,
                    model: new UniqueModel(
                        SettingsAccount,
                        { id: this.session.user.id }
                    ),
                });
            case 'blocking':
                return new SettingsBlockingView({
                    collection: this.getSettingsBlockListCollection(),
                });
            }
        },

        getTrackingSection: function (activeTab) {
            return activeTab;
        },

        trackOpenSection: function () {
            bus.trigger('openSection', this);
        },
    });

    withEmailVerificationAlert.call(SettingsLayout.prototype);

    return SettingsLayout;
});

